import GetData from "@/utils/request.js"

const {
  $get,
  $post
} = new GetData();

export const getSearchRes = ({
  keyword = '',
  type = 1,
  pageSize = 15
}) => $get(`/h5/search/search/${type}`, {
  keyword,
  pageSize,
})

export const getRecommend = (type = 1) => $get(`/h5/search/recommend/${type}`)

export default {
  getSearchRes,
  getRecommend,
}